
import {Component} from 'vue-property-decorator';
@Component({})
export default class PremiumBanner {
}
